export class SimpleFetchClient {
  constructor(endpoint) {
    this.endpoint = endpoint;
  }

  fetch() {
    return window.fetch(this.endpoint).then((res) => res.json());
  }

  fetchWithParams(params) {
    const url = new URL(
      window.location.protocol +
        '//' +
        window.location.hostname +
        '/' +
        this.endpoint,
    );
    params.forEach((entry) => url.searchParams.set(entry.param, entry.value));

    return window.fetch(url.toString()).then((res) => res.json());
  }
}

export default SimpleFetchClient;
